const FLAVOR_CONFIG = {
  development: {
    key: "development",
    appName: "Community Dev",
    logoSrc: "/logo-community-dev.svg",
    theme: {
      bodyBg: "#F6F5F4",
      sidebarBg: "#ffffff",
      activeBg: "#FDEEE9",
      activeText: "#772953",
      accent: "#E95420",
      accentHover: "#EB6536",
      accentDark: "#2C001E",
      cardBg: "rgba(249, 230, 222, 0.95)",
      textHeading: "#772953",
      textLabel: "#5E2750",
      btnHover: "#EB6536",
    },
  },
  production: {
    key: "production",
    appName: "Jiremali App",
    logoSrc: "/logo-jiremali-app.svg",
    theme: {
      bodyBg: "#F6F5F4",
      sidebarBg: "#ffffff",
      activeBg: "#FDEEE9",
      activeText: "#772953",
      accent: "#E95420",
      accentHover: "#EB6536",
      accentDark: "#2C001E",
      cardBg: "rgba(249, 230, 222, 0.95)",
      textHeading: "#772953",
      textLabel: "#5E2750",
      btnHover: "#EB6536",
    },
  },
  malisamaj: {
    key: "malisamaj",
    appName: "Mali Samaj",
    logoSrc: "/logo-malisamaj.svg",
    theme: {
      bodyBg: "#F6F5F4",
      sidebarBg: "#ffffff",
      activeBg: "#FDEEE9",
      activeText: "#772953",
      accent: "#E95420",
      accentHover: "#EB6536",
      accentDark: "#2C001E",
      cardBg: "rgba(249, 230, 222, 0.95)",
      textHeading: "#772953",
      textLabel: "#5E2750",
      btnHover: "#EB6536",
    },
  },
  thecodershub: {
    key: "thecodershub",
    appName: "Thecodershub",
    logoSrc: "/logo-thecodershub.svg",
    theme: {
      bodyBg: "#F5F7FA",
      sidebarBg: "#ffffff",
      activeBg: "#E3F2FD",
      activeText: "#1565C0",
      accent: "#2196F3",
      accentHover: "#1E88E5",
      accentDark: "#0D47A1",
      cardBg: "rgba(227, 242, 253, 0.95)",
      textHeading: "#1565C0",
      textLabel: "#1976D2",
      btnHover: "#1E88E5",
    },
  },
};

export const getCurrentFlavorKey = () => {
  const envFlavor = process.env.REACT_APP_ENV?.toLowerCase();
  if (envFlavor && FLAVOR_CONFIG[envFlavor]) {
    return envFlavor;
  }
  return "development";
};

export const getFlavorConfig = () => {
  const flavorKey = getCurrentFlavorKey();
  return FLAVOR_CONFIG[flavorKey] || FLAVOR_CONFIG.development;
};

export const applyFlavorBranding = () => {
  const config = getFlavorConfig();

  document.title = config.appName;

  const root = document.documentElement;
  root.style.setProperty("--app-body-bg", config.theme.bodyBg);
  root.style.setProperty("--app-sidebar-bg", config.theme.sidebarBg);
  root.style.setProperty("--app-active-bg", config.theme.activeBg);
  root.style.setProperty("--app-active-text", config.theme.activeText);
  root.style.setProperty("--app-accent", config.theme.accent);
  root.style.setProperty("--app-accent-hover", config.theme.accentHover);
  root.style.setProperty("--app-accent-dark", config.theme.accentDark);
  root.style.setProperty("--app-card-bg", config.theme.cardBg);
  root.style.setProperty("--app-text-heading", config.theme.textHeading);
  root.style.setProperty("--app-text-label", config.theme.textLabel);
  root.style.setProperty("--app-btn-hover", config.theme.btnHover);

  const favicon = document.querySelector("link[rel='icon']");
  if (favicon) {
    favicon.setAttribute("href", config.logoSrc);
  }

  return config;
};

export default FLAVOR_CONFIG;
